import React, { useContext } from 'react';
import { BreakpointContext, XLARGE } from '@core-ui/breakpoint-provider';
// @ts-ignore
import { RailContext } from '@cat/rail';
import { Accordion } from '@core-ui/accordion';
// @ts-ignore
import AccordionItem from './components/AccordionItem';
import { Option } from '../types';

type FacetBarProps = {
  appliedFacets: { [parameter: string]: Option[] };
  facets: [];
  isBRRedesignEnabled?: boolean;
  isSwitchContractEnabled?: boolean;
};

const FacetBar = ({
  appliedFacets,
  facets,
  isBRRedesignEnabled,
  isSwitchContractEnabled
}: FacetBarProps) => {
  const { smallerThan } = useContext(BreakpointContext);
  const { scrollableRef } = useContext(RailContext);
  const isMobile = smallerThan(XLARGE);

  return (
    <Accordion singlePanelExpanded sticky>
      {facets.map((facet, i) => (
        <AccordionItem
          /* eslint-disable-next-line react/no-array-index-key */
          key={i}
          appliedFacets={appliedFacets}
          facet={facet}
          isBRRedesignEnabled={isBRRedesignEnabled}
          isMobile={isMobile}
          isSwitchContractEnabled={isSwitchContractEnabled}
          scrollableElement={scrollableRef as HTMLElement}
        />
      ))}
    </Accordion>
  );
};

export default FacetBar;
